export interface Option {
  readonly label: string
  readonly value: string
}

export const createOption = (label: string, value?: string): Option => ({
  label,
  value: value || label,
  // value: value || label.toLowerCase().replace(/\W/g, ''),
})
